import { ActServiceApi } from 'api/ActServiceApi';
import { actClient } from 'container/actClient';

export const actServiceApi = new ActServiceApi(actClient);
